import axios from 'axios'
import qs from 'qs'
import { apiUrl } from '@/config/net'

class signUpModel {
  constructor () {
    this.formItem = {
      storeName: null,
      telephoneNum: null,
      passwordNum: null,
      url: `${apiUrl}/api/wechat.ashx`,
      signuping: false,
      sendSuccess: false,
      codeNum: '',
      codeWorking: false,
      codeTimeout: 60,
      timeSecond: '',
      timer: null
    }
  }

  _urlMaker (data) {
    let query = qs.stringify(data)
    return `${this.formItem.url}?${query}`
  }

  initFormData (query) {
    this.formItem.telephoneNum = query.telephoneNum
    this.formItem.storeName = query.storeName
    this.formItem.passwordNum = query.passwordNum
  }

  checkVertifyCode () {
    let url = this._urlMaker({
      type: 'checkvertifycode',
      phone: this.formItem.telephoneNum,
      code: this.formItem.codeNum
    })
    return axios.get(url).then(res => {
      let data = res.data
      return data
    }).catch(e => {
    })
  }

  getVerifyCode () {
    let url = this._urlMaker({
      type: 'sendvertifycode',
      phone: this.formItem.telephoneNum
    })
    return axios.get(url).then(res => {
      let data = res.data
      return data
    }).catch(e => {
      console.log(e)
      return Promise.reject(e)
    })
  }

  // 检测是否已注册
  haveSignup () {
    let url = this._urlMaker({
      type: 'checkphone',
      phone: this.formItem.telephoneNum
    })
    return axios.get(url).then(res => {
      let data = res.data
      return data
    }).catch(e => {
    })
  }

  submitSignupProcess () {
    this.checkVertifyCode()
      .then(() => {
        this.submitSignup()
      })
  }

  submitSignup () {
    let url = this._urlMaker({
      type: 'submitreginfo',
      phone: this.formItem.telephoneNum,
      pwd: this.formItem.passwordNum,
      code: this.formItem.codeNum
    })
    return axios.get(url).then(res => {
      this.formItem.signuping = false
      let data = res.data
      console.log(data)
      return data
    }).catch(e => {
    })
  }

  fireTimer () {
    if (this.formItem.timer) clearTimeout(this.formItem.timer)
    this.formItem.codeWorking = true
    let now = 0
    let timerProc = () => {
      now += 1
      if (now < this.formItem.codeTimeout) {
        this.formItem.timeSecond = `${this.formItem.codeTimeout - now} s`
        this.formItem.timer = setTimeout(timerProc, 1000)
      } else {
        this.formItem.codeWorking = false
      }
    }
    timerProc()
  }
}

export default signUpModel



// WEBPACK FOOTER //
// ./src/model/alpha-sign-up/form.js